/**
 * SEO statistics for search results pages
 * These values are hardcoded and can be updated periodically
 */

interface CityStats {
	yearlyVisits: number;
	buyersInLakhs: number;
}

export const seoStats: Record<string, CityStats> = {
	bengaluru: {
		yearlyVisits: 1000000, // Millions of visits conducted every year
		buyersInLakhs: 4, // 400,000+ buyers (4 lakhs)
	},
};

/**
 * Get SEO stats for a city (with fallback to bengaluru)
 */
export function getCityStats(city: string): CityStats {
	const normalizedCity = city.toLowerCase();
	return seoStats[normalizedCity] || seoStats.bengaluru;
}
